export function portalHref(portalBaseUrl: string | null, path: string): string {
  if (!portalBaseUrl) return path;
  return `${portalBaseUrl.replace(/\/$/, "")}${path}`;
}
